<p-blockUI [blocked]="loading$ | async">
  <div class="flex justify-center items-center h-full w-full backdrop-blur-sm bg-black/30">
    <div class="inline-grid place-items-center gap-3 rounded-xl bg-white/90 px-6 py-5 shadow-lg">
      <!-- Custom spinner image -->
      <img src="/logo.svg" alt="Loading" class="w-12 h-12 animate-spin" />

      <span class="text-sm font-medium text-slate-800">
        Setting up your organization and account…
      </span>

      <span class="text-xs text-slate-500"> Please don’t refresh or close this window </span>
    </div>
  </div>
</p-blockUI>
